import { Breakpoints } from '@material-ui/core/styles/createBreakpoints'
import { PaletteOptions } from '@material-ui/core/styles/createPalette'
import { Overrides } from '@material-ui/core/styles/overrides'

export const getComponents = (
  palette: PaletteOptions,
  breakpoints: Breakpoints,
  radius: string,
  fontFamily: string,
  themeColor: string,
  themeBackgroundColor: string
): Overrides => ({
  MuiAppBar: {
    colorPrimary: {
      background: themeBackgroundColor,
      backgroundColor: themeBackgroundColor,
      '&[class*="appBarTransparentTriggered"]': {
        background: themeBackgroundColor,
      },

      '& *': {
        color: `${themeColor} !important`,
      },
    },
  },
  MuiDivider: {
    root: {
      backgroundColor: palette.neutrals[100],
    },
  },
  MuiOutlinedInput: {
    root: {
      borderRadius: 0,
      borderColor: palette.primary[500],
    },
    notchedOutline: {
      borderColor: `${palette.primary[500]} !important`,
    },
  },
  MuiLink: {
    underlineHover: {
      textDecoration: 'underline',
    },
  },
  MuiCheckbox: {
    root: {
      color: palette.neutrals[200],
    },
    colorSecondary: {
      '&[class*="Mui-checked"]': {
        color: palette.primary.main,
      },
    },
  },
  MuiButton: {
    root: {
      borderRadius: `${radius}px`,
      fontSize: '0.8rem',
      fontWeight: 'bold',
      letterSpacing: '1px',
      textTransform: 'none',
    },
    sizeLarge: {
      fontSize: '0.9rem',
      padding: '0.7rem 1.4rem',
    },
    sizeSmall: {
      fontSize: '0.7rem',
      padding: '0.5rem 0.7rem',
    },
    outlinedPrimary: {
      '&.Mui-disabled.selectable': {
        color: palette.primary.main,
        borderColor: `${palette.primary.main} !important`,
        backgroundColor: palette.primary[50],
      },
    },
  },
  MuiPaper: {
    root: {
      borderRadius: 0,
    },
    rounded: {
      borderRadius: 0,
    },
  },
  MuiContainer: {
    root: {
      width: '90%',
    },
  },
  MuiCardMedia: {
    root: {
      userSelect: 'none',
    },
  },
  MuiInputLabel: {
    root: {
      color: palette.neutrals[50],
      fontSize: '1rem',
    },
  },
  MuiInputBase: {
    root: {
      color: palette.neutrals[50],
    },
    input: {
      height: '1em',
    },
  },
  MuiToolbar: {
    regular: {
      minHeight: '80px',
      padding: '0 1rem',
      [breakpoints.up('sm')]: {
        minHeight: '80px',
        padding: '0 2rem',
      },
      [breakpoints.up('md')]: {
        padding: '0 3rem',
      },
      [breakpoints.up('lg')]: {
        minHeight: '80px',
        padding: '0 4rem',
      },
    },
  },
  MuiTabs: {
    root: {
      borderBottom: `1px solid ${palette.neutrals[100]}`,
      color: 'black',
      '& .Mui-selected': {
        opacity: '1 !important',
        color: palette.primary[500],
      },
      '& .MuiTab-textColorInherit': {
        opacity: 0.6,
      },
    },
  },
  MuiTab: {
    root: {
      paddingLeft: '2px',
      paddingRight: '2px',
      marginRight: '2rem',
      minWidth: 'unset !important',
    },
    wrapper: {
      alignItems: 'start',
      width: 'unset',
    },
  },
  MuiTable: {
    root: {
      border: `2px solid ${palette.neutrals[900]}`,
      padding: '1rem 2rem',
      [breakpoints.down('sm')]: {
        padding: '0.75rem',
      },
      [breakpoints.down('xs')]: {
        padding: '0.5rem',
      },
      borderCollapse: 'separate',
      '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
        borderBottom: 'none',
      },
      '& .MuiTableCell-head': {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        borderBottom: `1px solid ${palette.primary[500]}`,
      },
    },
  },
  MuiTableCell: {
    root: {
      [breakpoints.down('sm')]: {
        padding: '0.75rem',
      },
      [breakpoints.down('xs')]: {
        padding: '0.5rem',
      },
    },
  },
  MuiCssBaseline: {
    '@global': {
      body: {
        backgroundColor: palette.neutrals[50],
      },
      '.MuiTabPanel-root': {
        padding: '0 !important',
      },
      header: {
        '& *': {
          fontFamily: `${fontFamily}, sans-serif!important`,
        },
      },
      '#footer': {
        background: themeBackgroundColor,
        '& > div': {
          background: themeBackgroundColor,
        },
        '& *': {
          fontFamily: `${fontFamily}, sans-serif!important`,
          color: `${themeColor}`,
        },
      },
      '#navigation-bar-menu': {
        background: themeBackgroundColor,
        '& > div': {
          background: themeBackgroundColor,
        },
        '& *': {
          fontFamily: `${fontFamily}, sans-serif!important`,
          color: `${themeColor}`,
        },
      },
    },
  },
})
